import formatAiCurrentScreen from './formatAiCurrentScreen';

import type IAiChatScreen from 'components/AiChat/interfaces/IAiChatScreen';
import type IAiChatContext from 'store/slices/aiChats/interfaces/IAiChatContext';

/**
 * Writes what the API is told about where the user is: the whole screen, as the chat holds it,
 * and the same place in one line for a prompt that wants no more than that.
 *
 * Nothing is left out but the display label, which goes in as the screen's name. The one-line
 * form is left out when the screen has no name to write it from.
 *
 * The payload mirrors the backend `ChatContextDto`. What the model sees, and how to add a field:
 * @see [9.3 What reaches the model](../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 * @see [12.9 Add a chat context field](../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 */
export default function toAiChatContext({
  label, screen, url, entities, customData, subScreens,
}: IAiChatScreen): IAiChatContext {
  const currentScreen = formatAiCurrentScreen({
    label, screen, url, entities, customData, subScreens,
  });

  return {
    currentScreen: currentScreen || undefined,
    screen: {
      id: screen,
      name: label.trim() || screen,
      url,
      entities,
      customData,
    },
    subScreens,
  };
}
